import * as actions from './actions'
import * as getters from './getters'
import * as types from '../mutation-types'

const state = {
  data: {},
  list: {},
  allResumes: [],
  resume: {},
  draft: {}
}

const mutations = {
  [types.RESUME_DATA] (state, data) {
    state.data = data
  },
  [types.RESUME_CHECKED] (state, payload) {
    if (typeof state.list.items !== 'undefined') {
      state.list.items = state.list.items.map(item => {
        if (item.id === payload.id) {
          if (typeof payload.force !== 'undefined') {
            item.checked = !!payload.force
          } else {
            item.checked = !item.checked
          }
        }
        return item
      })
    }
  },
  [types.RESUMES] (state, data) {
    if (typeof data.items !== 'undefined') {
      data.items = data.items.map(item => {
        if (typeof item.checked === 'undefined') {
          item.checked = false
        }
        return item
      })
    }
    state.list = data
  },
  [types.ALL_RESUMES] (state, data) {
    state.allResumes = data
  },
  [types.RESUME] (state, data) {
    state.resume = data
  },
  [types.DRAFT_RESUME] (state, data) {
    for (let x in data) {
      state.draft[x] = data[x]
    }
    state.draft = JSON.parse(JSON.stringify(state.draft))
  }
}

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}



// WEBPACK FOOTER //
// ./src/vuex/resumes/store.js